<template>
  <div class="point">
    <el-tabs type="border-card"
             @edit="handleTabsEdit"
             v-model="activetab">
      <el-tab-pane :label="item.name"
                   :name="item.title"
                   v-for="(item, index) in tabDatas"
                   :key="index"
                   :closable="item.title !== 'admin'"
                   :ref="item.title">
      </el-tab-pane>
    </el-tabs>
    <div class="content"
         v-if="activetab == 'admin'">
      <div class="header">
        <el-select v-model="name"
                   @change="getTableData"
                   placeholder="请选择"
                   size="mini">
          <el-option v-for="item in names"
                     :key="item.row_id"
                     :label="item.name"
                     :value="item.row_id">
          </el-option>
        </el-select>
        <el-input clearable
                  v-model="searchkey"
                  size="mini"
                  style="width: 150px; margin: 0 20px"></el-input>
        <el-button size="mini"
                   type="primary"
                   @click="getTableData"
                   style="margin-right:10px!important">搜索</el-button>
        <el-button type="primary"
                   size="mini"
                   @click="exportData">导出</el-button>
        <el-radio-group v-model="result"
                        style="margin-left: 20px"
                        @input="getTableData()"
                        v-show="typeIs">
          <el-radio :label="0">未中奖</el-radio>
          <el-radio :label="1">已中奖</el-radio>
        </el-radio-group>
      </div>
      <el-table stripe
                size="small"
                :header-cell-style="{
          background: '#eef1f6',
          padding: '1px 0px',
          color: 'black',
        }"
                style="width: 100%; font-size: 12px; color: black"
                ref="multipleTable5"
                :data="tableData"
                v-loading="loading"
                element-loading-text="拼命加载中"
                tooltip-effect="dark"
                height="calc(100% - 90px)">
        <el-table-column v-for="(item, index) in currentcloumn"
                         :key="index"
                         :prop="item.name"
                         :label="item.title"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <div v-if="item.name == 'pro_name'">
              <el-link style="font-size: 12px; color: black">
                <span @click="editData(scope.row)">{{
                  scope.row[item.name]
                }}</span>
              </el-link>
            </div>
            <div v-else-if="item.name == 'pro_type'">
              {{ types.filter(v=>v.row_id==scope.row[item.name])[0].name }}
            </div>
            <div v-else>
              {{ scope.row[item.name] }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <div style="display: flex; height: 23px; align-items: center">
              <el-button @click="editData(scope.row)"
                         type="text"
                         size="small"
                         style="margin-right: 10px !important">编辑</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="footer">
        <el-pagination :page-size.sync="PageSize"
                       small
                       background
                       @size-change="handleSizeChange"
                       layout="total, sizes, prev, pager, next, jumper"
                       :page-sizes="page_sizes"
                       :total="Count"
                       @current-change="onCurrentChange"
                       :current-page="currentPage"
                       style="margin-top: 5px">
        </el-pagination>
      </div>
    </div>
    <div class="content"
         v-if="activetab == 'edit'">
      <div class="formdata">
        <el-form ref="form2"
                 :rules="rules"
                 :model="form"
                 label-width="100px"
                 style="width: 30%"
                 size="mini">
          <el-form-item label="名称："
                        prop="pro_name">
            <el-input v-model="form.pro_name"
                      size="mini"
                      disabled></el-input>
          </el-form-item>
          <el-form-item label="用户：">
            <el-input v-model="form.user_name"
                      size="mini"
                      disabled></el-input>
          </el-form-item>
          <el-form-item label="用户手机号：">
            <el-input v-model="form.user_mobile"
                      size="mini"
                      disabled></el-input>
          </el-form-item>
          <el-form-item label="用户身份证：">
            <el-input v-model="form.user_idcard"
                      size="mini"
                      disabled></el-input>
          </el-form-item>
          <el-form-item label="用户单位：">
            <el-input v-model="form.user_department"
                      size="mini"
                      disabled></el-input>
          </el-form-item>
          <el-form-item label="类型："
                        prop="pro_type">
            <el-select v-model="form.pro_type"
                       placeholder="请选择"
                       disabled>
              <el-option v-for="item in types"
                         :key="item.row_id"
                         :label="item.name"
                         :value="item.row_id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="收货人："
                        prop="name">
            <el-input v-model="form.name"
                      size="mini"></el-input>
          </el-form-item>
          <el-form-item label="收货人手机："
                        prop="mobile">
            <el-input v-model="form.mobile"
                      size="mini"></el-input>
          </el-form-item>
          <el-form-item label="收货人地址："
                        prop="addr">
            <el-input v-model="form.addr"
                      size="mini"></el-input>
          </el-form-item>
          <el-form-item label="快递公司："
                        prop="express_number">
            <el-input v-model="form.express_number"
                      size="mini"></el-input>
          </el-form-item>
          <el-form-item label="快递单号："
                        prop="express_name">
            <el-input v-model="form.express_name"
                      size="mini"></el-input>
          </el-form-item>
          <el-form-item label="兑换码："
                        prop="pro_code">
            <el-input v-model="form.pro_code"
                      size="mini"
                      disabled></el-input>
          </el-form-item>
          <el-form-item label="兑换时间："
                        prop="create_time">
            <el-date-picker v-model="form.create_time"
                            type="datetime"
                            placeholder="选择开始时间"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            disabled>
            </el-date-picker>
          </el-form-item>
        </el-form>
        <div class="buttons">
          <el-button type="primary"
                     size="mini"
                     @click="edit()"
                     style="margin-right: 20px !important">保存</el-button>
          <el-button type="primary"
                     size="mini"
                     @click="close()">关闭</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pagiNation from "@/components/pagiNation";
export default {
  data () {
    return {
      property: "value",
      tableData: [],
      currentcloumn: [
        {
          title: "名称",
          name: "pro_name",
        },
        {
          title: "兑换人",
          name: "user_name",
        },
        {
          title: "兑换公司",
          name: "user_department",
        },
        {
          title: "类型",
          name: "pro_type",
        },
        {
          title: "收货人",
          name: "name",
        },
        {
          title: "收货人手机",
          name: "mobile",
        },
        {
          title: "收货人地址",
          name: "addr",
        },
        {
          title: "快递公司",
          name: "express_number",
        },
        {
          title: "快递单号",
          name: "express_name",
        },
        {
          title: "兑换码",
          name: "pro_code",
        },
        {
          title: "兑换时间",
          name: "create_time",
        },
      ],
      Count: 0,
      PageSize: 20,
      currentPage: 1,
      loading: false,
      searchkey: "",
      tabDatas: [
        {
          name: "兑换记录",
          title: "admin",
        },
      ],
      activetab: "admin",
      form: {},
      types: [
        {
          row_id: "1",
          name: "学时证明",
        },
        {
          row_id: "2",
          name: "实物",
        },
        {
          row_id: "3",
          name: "虚拟商品",
        },
        {
          row_id: "4",
          name: "虚拟兑换券",
        },
        {
          row_id:'5',
          name:"竞赛学习证明"
        },
        {
          row_id:'6',
          name:"日常学习证明"
        },
        {
         row_id:"9",
         name:"现金红包" 
        }
      ],
      rules: {
        start_time: [
          { required: true, message: "请选择开始时间", trigger: "blur" },
        ],
        end_time: [
          { required: true, message: "请选择结束时间", trigger: "blur" },
        ],
      },
      members: [],
      user: {},
      name: "",
      names: [],
      page_sizes: [20, 50, 100],
      result: 0,
    };
  },
  computed: {
    typeIs () {
      let item = this.names.filter((v) => v.row_id == this.name)[0];
      return item.type == "2"||item.type=='9';
    },
  },
  components: {
    pagiNation,
  },
  mounted () {
    this.getpros();
  },
  methods: {
    exportData () {
      let params = {
        pro_id: this.name,
        name: this.searchkey,
        pro_result: this.typeIs ? this.result : 0,
        pageNo: this.currentPage,
        pageNum: this.PageSize,
      };
      let url = this.$Api.outputpointlogMember + "&pro_id=" + this.name + "&name=" + this.searchkey + "&pro_result=" + (this.typeIs ? this.result : 0) + "&pageNo=" + this.currentPage + "&pageNum=" + this.PageSize
      window.open(url)
    },
    getpros () {
      let params = {
        pageNo: this.currentPage,
        pageNum: this.PageSize,
      };
      this.$http({
        url: this.$Api.getPointpro,
        methods: "GET",
        params,
      }).then((result) => {
        this.names = result.data.datalist;
        this.name = this.names[0].row_id || "";
        this.getTableData();
      });
    },
    del (form) {
      console.log("form :>> ", form);
      let params = {
        dataListId: form.row_id,
      };
      this.$http.get(this.$Api.recyclePointpro, { params }).then((res) => {
        if (res.data.errcode == "0") {
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.getTableData();
        } else {
          this.$message.error({
            message: "删除失败",
          });
        }
      });
    },
    edit () {
      this.$refs["form2"].validate((valid) => {
        if (valid) {
          let params = {
            name: this.form.name,
            mobile: this.form.mobile,
            addr: this.form.addr,
            express_number: this.form.express_number,
            express_name: this.form.express_name,
            dataId: this.form.row_id,
          };
          this.$http.get(this.$Api.modifyPointlog, { params }).then((res) => {
            if (res.data.errcode == "0") {
              this.$message({
                message: "保存成功",
                type: "success",
              });
              this.tabDatas = this.tabDatas.filter(
                (v) => v.title !== this.activetab
              );
              this.activetab = "admin";
              this.getTableData();
            } else {
              this.$message.error({
                message: "保存失败",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    editData (form) {
      this.form = form;
      let item = {
        name: form.pro_name + "-编辑",
        title: "edit",
      };
      let list = this.tabDatas.filter(
        (v) => v.title == "edit" || v.title == "add"
      );

      if (list.length == 0) {
        this.tabDatas.push(item);
      } else {
        this.tabDatas = this.tabDatas.filter(
          (v) => v.title !== "edit" && v.title !== "add"
        );
        this.tabDatas.push(item);
      }
      this.activetab = "edit";
    },
    add () {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let params = { data: this.form };
          this.$http.get(this.$Api.addPointpro, { params }).then((res) => {
            if (res.data.errcode == "0") {
              this.$message({
                message: "新增成功",
                type: "success",
              });
              this.tabDatas = this.tabDatas.filter(
                (v) => v.title !== this.activetab
              );
              this.activetab = "admin";
              this.getTableData();
            } else {
              this.$message.error({
                message: "新增失败",
              });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    close () {
      this.tabDatas = this.tabDatas.filter((v) => v.title !== this.activetab);
      this.activetab = "admin";
    },
    handleTabsEdit (a, b) {
      this.tabDatas = this.tabDatas.filter((v) => v.title !== a);
      this.activetab = "admin";
    },
    addData () {
      this.form = {};
      let item = {
        name: "新增",
        title: "add",
      };
      let list = this.tabDatas.filter(
        (v) => v.title == "add" || v.title == "edit"
      );

      if (list.length == 0) {
        this.tabDatas.push(item);
      } else {
        this.tabDatas = this.tabDatas.filter(
          (v) => v.title !== "edit" && v.title !== "add"
        );
        this.tabDatas.push(item);
      }
      this.activetab = "add";
    },
    getTableData () {
      this.loading = true;
      let params = {
        pro_id: this.name,
        name: this.searchkey,
        pro_result: this.typeIs ? this.result : 0,
        pageNo: this.currentPage,
        pageNum: this.PageSize,
      };
      this.$http({
        url: this.$Api.getPointlog,
        methods: "GET",
        params,
      })
        .then((result) => {
          this.loading = false;
          this.Count = result.data.total;
          this.tableData = result.data.datalist;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    handleSizeChange (e) {
      this.PageSize = e;
      this.getTableData();
    },
    onCurrentChange (e) {
      this.currentPage = e;
      this.getTableData();
    },
  },
};
</script>

<style lang="less" scoped>
.header {
  width: 100%;
  height: 50px;
  background-color: #fff;
  display: flex;
  align-items: center;
}
.content {
  background-color: #fff;
  width: 100%;
  height: calc(100vh - 80px);
  .footer {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .formdata {
    width: 100%;
    height: 100%;
    padding: 20px;
    overflow-y: auto;
  }
  .buttons {
    display: flex;
    padding-bottom: 40px;
    padding-left: 100px;
  }
}
/deep/.el-table {
  padding: 0 20px;
}
/deep/.el-input.is-disabled .el-input__inner {
  color: #666;
}
</style>